/**
 * @generated SignedSource<<d05b0e3dbaccaeeae8e3e0b8e436ca48>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type NativeIssueTableWithSelectedIssuesProvider_rankField$data = {
  readonly " $fragmentSpreads": FragmentRefs<"FooterRenderer_rank" | "IssueTable_rankField">;
  readonly " $fragmentType": "NativeIssueTableWithSelectedIssuesProvider_rankField";
};
export type NativeIssueTableWithSelectedIssuesProvider_rankField$key = {
  readonly " $data"?: NativeIssueTableWithSelectedIssuesProvider_rankField$data;
  readonly " $fragmentSpreads": FragmentRefs<"NativeIssueTableWithSelectedIssuesProvider_rankField">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "NativeIssueTableWithSelectedIssuesProvider_rankField",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "IssueTable_rankField"
    },
    {
      "kind": "FragmentSpread",
      "name": "FooterRenderer_rank"
    }
  ],
  "type": "JiraJqlFieldWithAliases"
};

(node as any).hash = "82614f163ab491b25be4a02199e7de19";

export default node;
